@if (showCarousel()) {
    <ms-event-carousel
        [isLoading]="isLoading()"
        [eventCarouselItems]="eventCarouselItems()"
        [activeEventId]="selectedEventId()"
        (eventTileClicked)="eventTileClicked($event)" />
} @else if (isLoading()) {
    <!-- skeleton loader on sheet view initial load -->
    <ul class="event-list-container">
        @for (event of [0, 1, 2]; track event) {
            <li class="event-list-item skeleton-item">
                <ms-event-carousel-skeleton />
            </li>
        }
    </ul>
}
